import React from "react";
import "../assets/css/main.css";
import heroImage from "../assets/img/hero-img.png";

function AboutUsComponent() {
  return (
    <section class="about-section bg-light-brown py-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12 mb-4 mb-lg-0 text-center">
            <div class="position-relative">
              <img
                src={heroImage}
                class="img-fluid mockup-img"
                alt="Cleonatech Website on Desktop and Mobile"
              />
            </div>
          </div>

          <div class="col-lg-6 col-md-12 about-content">
            <p class="agency-name">Cleonatech...</p>
            <h1 class="main-heading">
              Driving innovation through cutting-edge technology solutions
            </h1>

            <p class="intro-text">
              At Cleonatech, we specialize in creating innovative and reliable
              tech solutions tailored to meet the unique needs of our clients.
              Our dedicated team of experts leverages the latest technologies to
              drive digital transformation and deliver exceptional results.
            </p>

            <div class="services-list mb-4">
              <ul>
                <li>Branding & Design</li>
                <li>Web Design & Development</li>
                <li>SEO Search Engine Optimization</li>
                <li>Social Media Marketing</li>
                <li>Video Production</li>
                <li>Branding & Graphic Design</li>
              </ul>
            </div>

            <p class="intro-text mb-5">
              We pride ourselves on being a dedicated team of marketing
              professionals who strive to help our clients thrive, both offline
              and online. From Social Media Marketing to Google, Facebook,
              Instagram, LinkedIn, Pandora & Spotify campaigns, our team is
              ready to help!
            </p>

            <div class="row stats-row">
              <div class="col-4 stat-item">
                <p class="stat-number">10+</p>
                <p class="stat-label">Years Experience</p>
              </div>
              <div class="col-4 stat-item">
                <p class="stat-number">500+</p>
                <p class="stat-label">Projects</p>
              </div>
              <div class="col-4 stat-item">
                <p class="stat-number">+45%</p>
                <p class="stat-label">Web Traffic Growth</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUsComponent;
